import React from 'react';
import { Search, X } from 'lucide-react';
import PaginationControls from './PaginationControls';
import {
  masterSearchWrap,
  masterSearchInput
} from './masterPageStyles';

const SearchBar = ({
  value = '',
  onChange,
  placeholder = 'Search alphabetically...',
  totalItems = 0,
  currentPage = 1,
  pageSize = 10,
  onPageChange,
  onPageSizeChange
}) => {
  return (
    /* flex-col for Mobile/iPad (2 rows), md:flex-row for Laptop/Desktop (1 row) */
    <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-2 w-full mb-1 mt-1">
      
      {/* Search Input Box */}
      <div className={`relative flex-1 h-7 ${masterSearchWrap}`}>
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
        <input
          type="text"
          className={`${masterSearchInput} pl-8 pr-8 w-full h-full text-[11px]`}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none"
            title="Clear search"
          >
            <X size={12} />
          </button>
        )}
      </div>

      {/* Integrated Pagination Controls */}
      {onPageChange && (
        <div className="shrink-0 flex items-center h-8 justify-end">
          <PaginationControls
            totalItems={totalItems}
            currentPage={currentPage}
            pageSize={pageSize}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </div>
      )}
    </div>
  );
};

export default SearchBar;